import { Box, Container, Stack } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { theme } from './constants/theme';
import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/sections/HeroSection';
import ParadiseCloudSection from './components/sections/ParadiseCloudSection';
import DownloadSection from './components/sections/DownloadSection';
import FeaturesSection from './components/sections/FeaturesSection';
import VideoDialog from './components/dialogs/VideoDialog';
import SlidesDialog from './components/dialogs/SlidesDialog';
import { backgroundPattern } from './constants/styles';

function App() {
  const [videoOpen, setVideoOpen] = useState(false);
  const [slidesOpen, setSlidesOpen] = useState(false);

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <Box sx={{
          bgcolor: 'background.default',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}>
          <Box sx={backgroundPattern} />
          
          <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', flex: 1 }}>
            <Header />
            <Container maxWidth="lg" sx={{ py: 4 }}>
              <HeroSection 
                onVideoOpen={() => setVideoOpen(true)} 
                onSlidesOpen={() => setSlidesOpen(true)} 
              />
              <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} sx={{ mb: 4, alignItems: 'flex-start' }}>
                <ParadiseCloudSection />
                <DownloadSection />
              </Stack>
              <FeaturesSection onVideoOpen={() => setVideoOpen(true)} />
            </Container>
            <Footer />
          </Box>

          <VideoDialog 
            open={videoOpen} 
            onClose={() => setVideoOpen(false)} 
          />
          
          <SlidesDialog 
            open={slidesOpen} 
            onClose={() => setSlidesOpen(false)} 
          />
        </Box>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
